import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { parsedCurrentSheetAtom } from './atoms'
import {
  useAllFrameworks,
  useCommonCoreFrameworks,
} from 'domains/scope-and-sequence/hooks'
import { ItemSelect } from 'components/utility/ItemSelect'
import { useNewCrosswalkData } from './hooks'
import { FrameworkType } from 'domains/scope-and-sequence/types'

const frameworkLabels: Record<string, string> = {
  source_framework_id: 'Select State - Subject Database:',
  target_framework_id: 'Select CCSS - Subject Database:',
}

export function Frameworks() {
  const parsed = useAtomValue(parsedCurrentSheetAtom)
  if (!parsed) return null
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        Alignment Configuration
      </Typography>
      <Framework frameworkKey={'source_framework_id'} />
      <Framework frameworkKey={'target_framework_id'} />
    </Box>
  )
}

function Framework({
  frameworkKey,
}: {
  frameworkKey: 'target_framework_id' | 'source_framework_id'
}) {
  const parsed = useAtomValue(parsedCurrentSheetAtom)
  const { data, setData } = useNewCrosswalkData()
  const allFrameworks = useAllFrameworks()
  const commonCore = useCommonCoreFrameworks()

  const otherFrameworkKey =
    frameworkKey === 'source_framework_id'
      ? 'target_framework_id'
      : 'source_framework_id'

  const { [frameworkKey]: current, [otherFrameworkKey]: otherKey } = data

  if (!parsed || !allFrameworks || !commonCore) return null

  const label = frameworkLabels[frameworkKey] ?? frameworkKey

  const disabledItems = [allFrameworks.findIndex(({ id }) => id === otherKey)]

  return (
    <Box padding="5px">
      <ItemSelect<FrameworkType, number>
        fullWidth={true}
        label={label}
        items={
          frameworkKey === 'source_framework_id' ? allFrameworks : commonCore
        }
        disabledItems={disabledItems}
        currentVal={current}
        itemValue={({ id }) => id}
        itemDisplay={({ name }) => name}
        onValChange={(val) => setData({ ...data, [frameworkKey]: val })}
      />
    </Box>
  )
}
